var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3867 22.6133L23.9333 26.0667C23.4133 26.5867 22.5733 26.5867 22.0533 26.0667L18.6 22.6133C17.76 21.7733 18.36 20.3333 19.5467 20.3333L26.4533 20.3333C27.64 20.3333 28.2267 21.7733 27.3867 22.6133Z",
    fill: "#EE3C3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 45.5,
    width: 45,
    height: 45,
    rx: 14.5,
    transform: "rotate(180 45.5 45.5)",
    stroke: "#EE3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTrans);
export default __webpack_public_path__ + "static/media/failed_trans.f006790ba2e892af2f2c3251ace14040.svg";
export { ForwardRef as ReactComponent };